import React from "react";

const Privacy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800">
      <h1 className="text-4xl sm:text-5xl font-extrabold mb-8 text-center text-gray-800 underline decoration-indigo-500">
        Privacy Policy
      </h1>

      <p className="mb-4 font-medium">Effective Date: 27th June 2025</p>
      <p className="mb-4">
        <strong>TACTOS Strategic Solutions</strong> ("TACTOS," "we," "our," or
        "us") respects your privacy and is committed to protecting the personal
        data you share with us. This Privacy Policy outlines how we collect,
        use, share, and safeguard your information when you visit or use our
        website [www.tactos.in] and its services—including but not limited to
        the Business Ideation Hub, IT Solutions, Matrimony Platform, Job Portal,
        and Event Management tools.
      </p>
      <p className="mb-4">
        By using our services, you agree to the terms of this Privacy Policy.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        1. Information We Collect
      </h2>
      <p className="mb-2 font-medium">a. Personal Information</p>
      <ul className="list-disc list-inside mb-4">
        <li>Full name, date of birth, and gender</li>
        <li>Phone number and email address</li>
        <li>Address and location data</li>
        <li>Aadhaar or other identity verification (where applicable)</li>
        <li>Profile picture or avatar (optional)</li>
      </ul>
      <p className="mb-2 font-medium">b. Matrimony Information</p>
      <ul className="list-disc list-inside mb-4">
        <li>Religion, caste, mother tongue</li>
        <li>Height, weight, and marital status</li>
        <li>Lifestyle preferences (diet, smoking, drinking)</li>
        <li>Educational background and occupation</li>
        <li>Annual income and job details</li>
        <li>Family details (parents’ names, professions, etc.)</li>
        <li>Expectations from a partner</li>
      </ul>
      <p className="mb-2 font-medium">
        c. Job Portal and Career-Related Information
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>Current and previous employment details</li>
        <li>Resume/CV</li>
        <li>Fields of study, degrees, certifications</li>
        <li>Skills and language proficiencies</li>
        <li>LinkedIn or portfolio URLs (optional)</li>
      </ul>
      <p className="mb-2 font-medium">d. Startup and Company Information</p>
      <ul className="list-disc list-inside mb-4">
        <li>Startup/company name, industry sector, and registration details</li>
        <li>Product or service offerings</li>
        <li>Budget, funding stage, and business goals</li>
        <li>CA compliance and documentation details</li>
      </ul>
      <p className="mb-2 font-medium">e. Technical and Usage Data</p>
      <ul className="list-disc list-inside mb-4">
        <li>IP address</li>
        <li>Browser and device type</li>
        <li>Pages visited and time spent</li>
        <li>Cookies and tracking preferences</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        2. How We Use Your Information
      </h2>
      <p className="mb-2">We use your data to:</p>
      <ul className="list-disc list-inside mb-4">
        <li>Provide matchmaking services and match profiles</li>
        <li>Suggest relevant jobs or internships based on your profile</li>
        <li>Help startups receive appropriate business, tech, or CA support</li>
        <li>Enable IT service quotations and proposals</li>
        <li>Manage events, registrations, and communications</li>
        <li>Improve user experience on our platform</li>
        <li>Respond to queries and technical issues</li>
        <li>Send updates, alerts, and service messages</li>
        <li>Comply with legal and regulatory requirements</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        3. Sharing of Information
      </h2>
      <p className="mb-2">
        Your data may be shared under the following circumstances:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>
          With prospective matrimonial matches (based on your privacy settings)
        </li>
        <li>
          With potential employers or recruiters (if you apply via our Job
          Portal)
        </li>
        <li>With verified CA or tech service providers on our platform</li>
        <li>With internal teams to deliver support or resolve issues</li>
        <li>With regulatory authorities, if legally required</li>
        <li>
          With third-party vendors (e.g., cloud storage, payment gateways)
        </li>
      </ul>
      <p className="mb-4">
        We <span className="font-bold">do not sell</span> your personal data to
        third parties.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Data Security</h2>
      <p className="mb-4">
        We take data protection seriously. Your information is stored on secure
        servers with appropriate encryption, firewalls, and access controls.
        Despite this, no system is completely foolproof, so we encourage users
        to maintain good security practices.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Your Rights</h2>
      <p className="mb-2">You can:</p>
      <ul className="list-disc list-inside mb-4">
        <li>View or edit your personal data</li>
        <li>Request deletion of your profile and data</li>
        <li>
          Withdraw consent for data sharing (which may affect access to
          services)
        </li>
        <li>Set privacy preferences (especially for matrimony visibility)</li>
      </ul>
      <p className="mb-4">
        For assistance, email us at{" "}
        <a
          href="mailto:tactosinfo@gmail.com"
          className="text-blue-600 underline"
        >
          tactosinfo@gmail.com
        </a>
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Data Retention</h2>
      <p className="mb-4">
        We retain data only as long as necessary for the purpose it was
        collected, or as required by law. If you delete your account, your data
        will be permanently deleted within 60 days unless legally required to
        retain it.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Children’s Privacy</h2>
      <p className="mb-4">
        Our platform is not intended for individuals under the age of 18. We do
        not knowingly collect information from minors. If we become aware of
        such data, we will delete it.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        8. Cookies and Tracking
      </h2>
      <p className="mb-4">
        We use cookies to improve your experience and analyze site performance.
        You may control cookie settings through your browser.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">9. Third-Party Links</h2>
      <p className="mb-4">
        TACTOS may contain links to external websites. We are not responsible
        for their content or privacy practices. Please review their policies
        before sharing data.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        10. Updates to This Policy
      </h2>
      <p className="mb-4">
        We may update this Privacy Policy from time to time. The latest version
        will always be available at{" "}
        <a href="www.tactos.in" className="text-blue-600 underline">
          www.tactos.in
        </a>{" "}
        Continued use of our services after changes indicates your acceptance.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">11. Contact Us</h2>
      <p className="mb-2">
        For questions or concerns regarding this Privacy Policy:{" "}
      </p>
      <p className="mb-4">
        <strong>TACTOS Strategic Solutions</strong>
        <br />
        Email:{" "}
        <a
          href="mailto:tactosinfo@gmail.com"
          className="text-blue-600 underline"
        >
          tactosinfo@gmail.com
        </a>
      </p>
    </div>
  );
};

export default Privacy;
